export default __webpack_public_path__ + "static/media/Kandariya-Mahadev-Temple-khajuraho.66f9e1f8.jpg";